document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.tab-collection-section').forEach((section) => {
    section.querySelectorAll('.tabs-collection-column').forEach(container => {
      const initialLimit = parseInt(container.dataset.initialLimit);
      const products = container.querySelectorAll('.flex-grid__item');
      products.forEach((product, index) => {
        if (index >= initialLimit) {
          product.classList.add('hidden-product');
        }
      });
    });
    const buttons = section.querySelectorAll('.tabs-collection-title');
    const listContainers = section.querySelectorAll('.tabs-collection-column');

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const blockId = button.dataset.blockId;
        listContainers.forEach((column) => {
          column.classList.toggle('is-active', column.dataset.blockId === blockId);
        });
        buttons.forEach((title) => {
          title.classList.toggle('is-active', title.dataset.blockId === blockId);

          if (title.dataset.blockId === blockId) {
            const container = title.parentElement;
            const buttonWidth = title.offsetWidth;
            const containerWidth = container.offsetWidth;
            const buttonPosition = title.offsetLeft;
            const scrollPosition = buttonPosition - (containerWidth / 2) + (buttonWidth / 2);

            container.scrollTo({
              left: scrollPosition,
              behavior: 'smooth'
            });
          }
        });
      });
    });
    section.querySelectorAll('.load-more-button').forEach((button) => {
      button.dataset.state = 'collapsed';

      button.addEventListener('click', function () {
        const blockId = this.dataset.blockId;
        const container = section.querySelector(`.tabs-collection-column[data-block-id="${blockId}"]`);
        const initialLimit = parseInt(container.dataset.initialLimit);
        const allProducts = container.querySelectorAll('.flex-grid__item');

        if (this.dataset.state === 'collapsed') {
          let shown = 0;
          for (let i = 0; i < allProducts.length && shown < initialLimit; i++) {
            if (allProducts[i].classList.contains('hidden-product')) {
              allProducts[i].classList.remove('hidden-product');
              shown++;
            }
          }

          const remaining = container.querySelectorAll('.hidden-product').length;
          if (remaining === 0) {
            this.textContent = 'VIEW LESS';
            this.dataset.state = 'expanded';
          }
        } else {
          allProducts.forEach((product, index) => {
            if (index >= initialLimit) {
              product.classList.add('hidden-product');
            }
          });
          this.textContent = 'LOAD MORE';
          this.dataset.state = 'collapsed';
          const titleContainer = section.querySelector('.blocking-title');
          if (titleContainer) {
            titleContainer.scrollIntoView({ behavior: 'smooth' });
          }
        }
      });
    });
  });
});